import { Play, Download } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export const VideoGrid = ({ videos, onDownload }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="videos-grid">
      {videos.length === 0 ? (
        <p className="col-span-full text-center py-12 text-muted-foreground">
          No videos yet. Generate your first AI video!
        </p>
      ) : (
        videos.map((video) => (
          <div
            key={video.id}
            className="border border-border p-4 bg-surface hover:-translate-y-1 transition-all"
            data-testid={`video-card-${video.id}`}
          >
            <div className="aspect-video bg-black/50 mb-3 flex items-center justify-center">
              <Play size={48} className="text-white/50" />
            </div>
            <p className="text-sm mb-2 line-clamp-2">{video.prompt}</p>
            <div className="flex items-center justify-between text-xs text-muted-foreground mb-3">
              <span>{video.duration}s</span>
              <span>{video.size}</span>
              <span>{video.model}</span>
            </div>
            <Button
              onClick={() => onDownload(video.id)}
              size="sm"
              className="w-full bg-white text-black hover:bg-gray-200"
              data-testid={`download-video-${video.id}`}
            >
              <Download size={16} className="mr-2" />
              Download
            </Button>
          </div>
        ))
      )}
    </div>
  );
};
